import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SurveyWrapper = styled(Grid)`
  display: flex;
`;

export const VerticalTextDivider = styled('span')`
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.neutral.shades.shade300};
  width: 4px;
  margin-right: 24px;
`;

export const StyledButton = styled('button')`
  background-color: transparent;
  text-decoration: none;
  underline: none;
  border: none;
`;
